/**
 * Polyfill for PublicKeyCredential.parseRequestOptionsFromJSON
 */
function decodeBase64Url(base64url: Base64URLString): ArrayBuffer {
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const binStr = window.atob(base64);
    const bin = new Uint8Array(binStr.length);
    for (let index = 0; index < binStr.length; index += 1) {
        bin[index] = binStr.charCodeAt(index);
    }
    return bin.buffer;
}

function mapAllowCredentialsToJSON(
    allowCredentials?: PublicKeyCredentialDescriptorJSON[],
): PublicKeyCredentialDescriptor[] | undefined {
    if (!allowCredentials) {
        return undefined;
    }
    return allowCredentials.map(
        (allowCredential) => ({
            ...allowCredential,
            id: decodeBase64Url(allowCredential.id),
            transports: allowCredential.transports as AuthenticatorTransport[] | undefined,
            type: allowCredential.type as PublicKeyCredentialType,
        }),
    );
}

export function parseRequestOptionsFromJSON(
    options: PublicKeyCredentialRequestOptionsJSON,
): PublicKeyCredentialRequestOptions {
    if (window.PublicKeyCredential && window.PublicKeyCredential.parseRequestOptionsFromJSON) {
        return window.PublicKeyCredential.parseRequestOptionsFromJSON(options);
    }

    const challenge = decodeBase64Url(options.challenge);
    return {
        ...options,
        allowCredentials: mapAllowCredentialsToJSON(options.allowCredentials),
        challenge,
        userVerification: options.userVerification as UserVerificationRequirement,
    };
}
